module.exports = __webpack_public_path__ + "img/shadow_drake_small.77e9c057.png";